<div>
    <div class="cancel_details">
        <div class="dlt">
            <!-- <div>
                <img src="../../../../assets/image/mdi_alert.svg" alt="">
            </div> -->
            <div>
                <span class="Dlt_title">{{ data.title || 'Meal item request Delete' }}</span>
            </div>
        </div>
        <p class="dlt_mge">{{ data.message || 'Are you sure you want to delete this meal item?' }}</p>
        <div class="selected_list" [class.selected_list--single]="data.singleAction">
            <button class="cancel" *ngIf="!data.singleAction" (click)="cancel()">Cancel</button>
            <button
                [ngClass]="{
                    update: data.confirmLabel === 'Update' || data.confirmLabel === 'Submit' || data.confirmLabel === 'OK' || data.confirmLabel === 'Add',
                    delete: !data.singleAction && data.confirmLabel !== 'Update' && data.confirmLabel !== 'Submit' && data.confirmLabel !== 'OK' && data.confirmLabel !== 'Add'
                }"
                (click)="confirm()">
                {{ data.confirmLabel || 'Delete' }}
            </button>
        </div>
    </div>
</div>

